var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipelineAddTour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ADD_PIPE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 42.377 42.375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            #ADD_PIPE .cls-1,\n            #ADD_PIPE .cls-2{\n            fill:#f5f5f5\n            }\n            #ADD_PIPE .cls-2{\n            stroke:rgba(0,0,0,0);\n            stroke-miterlimit:10\n            }\n            #ADD_PIPE .cls-3{\n            filter:url(#Vereinigungsmenge_20)\n            }\n            #ADD_PIPE .cls-4{\n            filter:url(#Differenzmenge_2)\n            }\n        "), /*#__PURE__*/React.createElement("filter", {
    id: "Differenzmenge_2",
    width: 39.862,
    height: 42,
    x: 0,
    y: 0.374,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Vereinigungsmenge_20",
    width: 37.834,
    height: 29.359,
    x: 4.543,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00c4ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-4",
    transform: "translate(0 .004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_2-2",
    d: "M4007-3231a17.886 17.886 0 0 1-7.006-1.415 17.944 17.944 0 0 1-5.721-3.858 17.944 17.944 0 0 1-3.858-5.721A17.886 17.886 0 0 1 3989-3249a17.979 17.979 0 0 1 2.47-9.108 18.051 18.051 0 0 1 6.49-6.452 17.582 17.582 0 0 1 7-2.321 17.316 17.316 0 0 1 2.04-.12 17.96 17.96 0 0 1 5.035.726v2.1A15.831 15.831 0 0 0 4007-3265a13.769 13.769 0 0 0-2.04.139 15.783 15.783 0 0 0-7 2.67A16 16 0 0 0 3991-3249a16.018 16.018 0 0 0 16 16 15.8 15.8 0 0 0 7.173-1.7 16.2 16.2 0 0 0 5.507-4.55c.306-.4.6-.817.869-1.25h2.313c-.231.438-.477.857-.732 1.25a18.116 18.116 0 0 1-6.383 5.985A18.008 18.008 0 0 1 4007-3231z",
    className: "cls-2",
    "data-name": "Differenzmenge 2",
    transform: "translate(-3986 3270.37)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3",
    transform: "translate(0 .004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_20-2",
    d: "M4012.125-3244.794h-25.668c-1.425 0-2.5-1.936-2.5-4.5s1.075-4.5 2.5-4.5h25.8a.48.48 0 0 1 .225.062c1.327.167 2.309 2.02 2.309 4.467 0 2.565-1.075 4.5-2.5 4.5a1.5 1.5 0 0 1-.166-.029zm.114-7.959c-.013 0-.026.013-.038.015-.339.06-.689.445-.957 1.055l-.016.043a4.562 4.562 0 0 0-.163.443c-.02.066-.035.141-.054.211-.03.118-.063.233-.089.361s-.041.263-.058.4c-.012.084-.028.162-.036.251a7.37 7.37 0 0 0 0 1.434c0 .017.006.031.007.048.022.214.052.421.093.615 0 .021.01.039.014.061.039.182.083.36.135.524.019.062.042.115.064.173.038.109.078.22.121.317a3.242 3.242 0 0 0 .168.318l.042.077a1.2 1.2 0 0 0 .75.62.509.509 0 0 1 .068.022c.707 0 1.5-1.5 1.5-3.5s-.792-3.5-1.5-3.5c-.016-.001-.034.012-.051.013zm-27.282 3.459c0 2 .792 3.5 1.5 3.5h24.222l-.017-.032a4.213 4.213 0 0 1-.321-.589l-.049-.112a5.6 5.6 0 0 1-.223-.655c-.016-.058-.035-.112-.05-.17a7.047 7.047 0 0 1-.135-.718c-.01-.068-.025-.134-.034-.2a8.47 8.47 0 0 1-.058-.991 8.37 8.37 0 0 1 .063-1.01c.007-.057.019-.108.027-.163a7.014 7.014 0 0 1 .153-.791c.009-.035.02-.066.029-.1a5.519 5.519 0 0 1 .266-.757l.013-.03a3.951 3.951 0 0 1 .379-.676h-24.264c-.709-.006-1.501 1.488-1.501 3.495zm1.735 2.764v-.5h21.89v.5zm22.023-10.6v-4h-4v-2h4v-4h2v4h4v2h-4v4z",
    className: "cls-1",
    "data-name": "Vereinigungsmenge 20",
    transform: "translate(-3975.91 3270.62)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelineAddTour);
export default __webpack_public_path__ + "static/media/pipeline-add-tour.e7b281942eced984a670df0e2870778e.svg";
export { ForwardRef as ReactComponent };